import axios from "axios";
import { getUserTimezone } from "../utils/timezone";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

api.interceptors.request.use((config) => {
	config.headers = config.headers || {};
	config.headers["X-Client-App"] = "frontend";
	config.headers["X-User-Timezone"] = getUserTimezone();
	return config;
});

export const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

export default api;
